module.exports = __webpack_public_path__ + "img/search_doc_icon.1e21b8a7.svg";